export enum TargetUrl {
  sameWindow = '_self',
  newWindow = '_blank',
}
